import script from "./OrderCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderCreateModal.vue?vue&type=style&index=0&id=4da5287d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da5287d"]])

export default __exports__